import { useQuery } from "@tanstack/react-query";
import { getLinkedTracks } from "../api";

export const useLinkedTracksQuery = ({ uid }: { uid?: string }) => {
  const query = useQuery({
    queryKey: ["linked-tracks", uid],
    queryFn: () => getLinkedTracks(uid),
    enabled: !!uid,
    select: (data) => {
      if (!data) return undefined;
      return data.data;
    },
  });

  return { ...query, data: query.data };
};
